// /opt/isp_erp/frontend/src/components/warehouse/RevisionEquipoDialog.jsx
import React, { useState } from "react";
import {
  Typography, TextField, Alert, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import axios from "../../api/axios";
import { mensajeError } from "../../utils/mensajesError";
import TipoFallaSelect from "./TipoFallaSelect";

const API = "/warehouse/sucursales-equipos";

/** Equipo de una sucursal: lo pone en revisión, o resuelve la revisión (solucionado / enviar a la central como RMA). */
export default function RevisionEquipoDialog({ equipo, onClose, onHecho }) {
  const enRevision = !!equipo.en_revision;
  const [resultado, setResultado] = useState("SOLUCIONADO");
  const [tipoFalla, setTipoFalla] = useState("");
  const [nota, setNota] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);

  const guardar = async () => {
    setError("");
    if (!enRevision && nota.trim().length < 3) { setError("Anota qué falla tiene el equipo"); return; }
    if (enRevision && resultado === "NO_SOLUCIONADO") {
      if (!tipoFalla) { setError("Elige el tipo de falla"); return; }
      if (nota.trim().length < 3 && !equipo.nota_revision) { setError("Anota el diagnóstico del equipo"); return; }
    }
    setEnviando(true);
    try {
      const r = enRevision
        ? await axios.post(`${API}/resolver-revision`, {
            sn: equipo.sn, resultado, nota: nota.trim() || null,
            tipo_falla: resultado === "NO_SOLUCIONADO" ? tipoFalla : null,
          })
        : await axios.post(`${API}/poner-en-revision`, { sn: equipo.sn, nota: nota.trim() });
      onHecho(r.data.mensaje);
    } catch (e) {
      setError(mensajeError(e, "No se pudo registrar el cambio"));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open onClose={enviando ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{enRevision ? "Resolver revisión" : "Poner en revisión"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>{equipo.sn}</strong> · {equipo.modelo}
          {enRevision && equipo.nota_revision && (
            <Typography variant="caption" color="text.secondary" display="block">Falla anotada: {equipo.nota_revision}</Typography>
          )}
        </Typography>

        {enRevision ? (
          <>
            <RadioGroup value={resultado} onChange={(e) => setResultado(e.target.value)}>
              <FormControlLabel value="SOLUCIONADO" control={<Radio />} label="Solucionado: vuelve a estar disponible en la sucursal" />
              <FormControlLabel value="NO_SOLUCIONADO" control={<Radio />} label="No se pudo solucionar: enviar a la central para RMA" />
            </RadioGroup>
            {resultado === "NO_SOLUCIONADO" && (
              <TipoFallaSelect value={tipoFalla} onChange={(valor) => setTipoFalla(valor)} required />
            )}
            <TextField fullWidth size="small" multiline minRows={2} sx={{ mt: 2 }}
              label={resultado === "NO_SOLUCIONADO" ? "Diagnóstico (si lo dejas vacío se usa la falla anotada)" : "Qué se hizo (opcional)"}
              value={nota} onChange={(e) => setNota(e.target.value)} />
          </>
        ) : (
          <TextField fullWidth size="small" multiline minRows={2} autoFocus label="Falla que presenta (obligatorio)"
            value={nota} onChange={(e) => setNota(e.target.value)}
            helperText="Mientras esté en revisión no se puede asignar a un técnico" />
        )}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={enviando}>Cancelar</Button>
        <Button variant="contained" onClick={guardar} disabled={enviando}>{enviando ? "Guardando..." : "Guardar"}</Button>
      </DialogActions>
    </Dialog>
  );
}
